import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw_thoughts_e49y.svg';

export const ThoughtsMatterStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <S.ContentRow>
        <S.ContentColumn md={14}>
            <S.StepHeading>{t('week-5.thoughts-matter.title')}</S.StepHeading>

            <S.StepDescription small>
                <Trans i18nKey={'week-5.thoughts-matter.description.1'}>
                    "As you can see from this example, your <S.StyledWord> thoughts</S.StyledWord>
                    or
                    <S.StyledWord> interpretations</S.StyledWord> about an event will really
                    influence how you feel about it and what you do in response."
                </Trans>
            </S.StepDescription>
            <S.StepDescription small>{t('week-5.thoughts-matter.description.2')}</S.StepDescription>
            <S.StepDescription small>{t('week-5.thoughts-matter.description.3')}</S.StepDescription>
        </S.ContentColumn>
        <S.ContentColumn md={10}>
            <S.StepIcon large iconUrl={stepIcon} />
        </S.ContentColumn>
    </S.ContentRow>
));
